import React, { useRef, useState } from "react";
import { Button } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { useTranslation } from "react-i18next";

const Avatar = ({name, url, onChange, onRemove}) => {
    const inputRef = useRef();
    const { t } = useTranslation("common");

    return (
        <div className="main-content__upload-field">
            <div className={`main-content__upload-field-wrap ${url ? "main-content__upload-field-wrap--uploaded" : ""}`}>
                <div className={`main-content__upload-buttons ${url ? "main-content__upload-buttons--uploaded" : ""}`}>
                    <button type="link" className="main-content__remove-upload" onClick={onRemove}>
                        <i className="fa-regular fa-trash-can"></i>
                        <span>Remove Image</span>
                    </button>
                </div>
                <div className={`main-content__upload-box ${url ? "main-content__upload-box--uploaded" : ""}`} id="uploadBox" onClick={() => { inputRef?.current?.click() }}>
                    <img className={`main-content__upload-img ${url ? "main-content__upload-img--uploaded" : ""}`} src={url} alt="Uploaded Image" />
                    {!url && (
                            <>
                                <div className="main-content__upload-box-text">
                                    <i className="fa-light fa-file-image"></i>
                                    <div id="uploadText">{t("uploadAvatar")}</div>
                                    <div>
                                        <br /> <span>{t("browse")}</span>
                                    </div>
                                </div>
                                <input type="file" name={name} ref={inputRef} hidden accept="image/*" onChange={onChange} />
                            </>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default Avatar;
